import { Form } from '../../components/Shared/FormEngine/FormEngine.types';

const pickUpReturn: Form = [
  {
    kind: 'field',
    name: 'topInfo',
    fieldLabel: '*Required fields',
    fieldType: 'text',
    required: true,
    optionsAutoSelected: false,
    permissionSets: [],
  },
  {
    kind: 'section',
    fields: [
      {
        kind: 'field',
        name: 'tabNavigator',
        fieldLabel: 'Tab Navigator',
        fieldType: 'tabNavigator',
        required: false,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        isShow: true,
        optionsAutoSelected: false,
        optionsDependentField: [],
        optionsStatic: [
          { value: 'details', label: 'Details' },
          { value: 'parts', label: 'Parts' },
        ],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'salesRep',
        isShow: true,
        fieldLabel: 'Sales Rep',
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        optionsPlaceHolder: 'Sales Rep',
        optionsDynamic: 'getSalesReps',
        optionsAutoSelected: false,
        optionsDependentField: [],
        permissionSets: [],
        isFailed: true,
      },
      {
        kind: 'field',
        name: 'primaryAccount',
        fieldLabel: 'Account',
        isShow: true,
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        optionsPlaceHolder: 'Pick an Account',
        optionsDynamic: 'getAccounts',
        optionsAutoSelected: false,
        optionsDependentField: ['salesRep'],
        permissionSets: [],
        isFailed: true,
      },
      {
        kind: 'field',
        name: 'shipTo',
        fieldLabel: 'Ship To',
        isShow: true,
        fieldType: 'selectSingleDynamicAutoCompletePicker',
        required: true,
        optionsPlaceHolder: 'Pick a Value',
        optionsDynamic: 'getShipToAddresses',
        optionsDependentField: ['primaryAccount'],
        optionsAutoSelected: false,
        permissionSets: [],
        isFailed: true,
      },
      {
        kind: 'field',
        name: 'requestedPickupDate',
        fieldLabel: 'Requested Pickup Date',
        fieldType: 'dateTimePicker',
        required: true,
        isShow: true,
        optionsAutoSelected: false,
        date: true,
        time: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'liftGateNeeded',
        fieldLabel: 'Lift Gate Needed',
        fieldType: 'toggleSwitch',
        required: false,
        isShow: true,
        optionsAutoSelected: false,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'dockAvailable',
        fieldLabel: 'Dock Available',
        fieldType: 'toggleSwitch',
        required: false,
        optionsAutoSelected: false,
        isShow: true,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'shortTruckOnly',
        fieldLabel: 'Short Truck Only',
        fieldType: 'toggleSwitch',
        required: false,
        optionsAutoSelected: false,
        isShow: true,
        optionsPlaceHolder: '',
        optionsDynamic: '',
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'onsiteContractName',
        fieldLabel: 'Onsite Contact Name',
        isShow: true,
        fieldType: 'input',
        required: true,
        optionsPlaceHolder: 'Onsite Contact Name',
        optionsDynamic: '',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'onsiteContractPhone',
        fieldLabel: 'Onsite Contact Phone',
        isShow: true,
        fieldType: 'input',
        required: true,
        optionsPlaceHolder: 'Onsite Contact Phone',
        optionsDynamic: '',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'onsiteContractEmail',
        fieldLabel: 'Onsite Contact Email',
        fieldType: 'input',
        isShow: true,
        required: false,
        optionsPlaceHolder: 'Onsite Contact Email',
        optionsDynamic: '',
        optionsDependentField: [],
        optionsAutoSelected: false,
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'onsiteContractInstructions',
        fieldLabel: 'Onsite Instructions',
        isShow: true,
        fieldType: 'textArea',
        required: false,
        optionsPlaceHolder: "Onsite Instructions (e.g. Dock Hours, 48' or 53' Truck, etc.)",
        showOnWeb: true,
        optionsAutoSelected: false,
        permissionSets: [],
        showTooltip: true,
        characterLimit: 32000,
      },
      {
        kind: 'field',
        name: 'Attachments',
        fieldLabel: 'Attachments',
        fieldType: 'Attachments',
        required: false,
        isShow: true,
        optionsAutoSelected: false,
        optionsDependentField: [],
        permissionSets: [],
      },
      {
        kind: 'field',
        name: 'comments',
        fieldLabel: 'Comments',
        fieldType: 'comments',
        required: false,
        isShow: true,
        optionsAutoSelected: false,
        characterLimit: 32000,
        optionsPlaceHolder:
          'Do not use to enter patient information, complaints, or set extension request.',
        showOnWeb: true,
        permissionSets: [],
      },
    ],
  },
];

export default pickUpReturn;
